import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { fidelizacao } from "../../services/api";
import Fidelizacao from "./fidelizacao";
import Fidelizacao_serie_rede from "./Fidelizacao_serie_rede";
import Fidelizacao_seg_rede from "./Fidelizacao_seg_rede";
import Fidelizacao_serie_comparativa from "./fidelizacao_serie_comparativa";

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

const Fidelizacao_Rede = (props) => {

    let datainicio = props.di;
    let datafim = props.df;



    return (
        <div className="fidelizacao_rede">
            <Tabs
                defaultActiveKey="Unidade"
                id="uncontrolled-tab-example"
                className="mb-3"
            >
                <Tab eventKey="Unidade" title="Unidade">
                    <center>
                        <h4>
                            Fidelização por Unidade

                        </h4>
                        <Fidelizacao di={datainicio} df={datafim} />

                    </center>
                </Tab>
                <Tab eventKey="Serie" title="Série">
                    <center>
                        <h4>
                            Fidelização por Série

                        </h4>
                        <   Fidelizacao_serie_rede di={datainicio} df={datafim} />

                    </center>
                </Tab>
                {/* <Tab eventKey="Segmento" title="Segmento">
                    <center>
                        <h4>
                            Fidelização por Segmento

                        </h4>
                        <   Fidelizacao_seg_rede di={datainicio} df={datafim} />

                    </center>
                </Tab> */}
                <Tab eventKey="compara" title="Comparação">
                    <center>
                        <h4>
                            Fidelização por Série Comparativa

                        </h4>
                        <   Fidelizacao_serie_comparativa di={datainicio} df={datafim} />

                    </center>
                </Tab>
            </Tabs>

        </div>
    );
};
export default Fidelizacao_Rede;